module.exports = __webpack_public_path__ + "static/1-asset-4-d@2x-b51ba7507e4faeaa19e65dcaaf28cfad.png";